import { useQuery, useQueryClient } from 'react-query';
import api from 'client';

export default (messageId) => {
  const queryClient = useQueryClient();

  const { data, isLoading, isSuccess } = useQuery(['GET', `/apis/v2/messages/${messageId}`, {}], {
    onSuccess: async () => {
      await api.put(`/apis/v2/messages/${messageId}/read`, {});
      queryClient.invalidateQueries(['GET', '/apis/v2/messages/inbox', { page: 1, per: 1 }]);
      queryClient.invalidateQueries(['GET', '/apis/v2/messages/inbox', { per: 10 }]);
    },
  });
  return { data: data?.data?.attributes?.messages || [], participants: data?.data?.attributes?.accounts || [], meta: data?.data, isLoading, isSuccess };
};
